{
  "example_demo": "Example",
  "example_i18n": "I18n",
  "example_icon": "Icon",
  "example_responsive": "Responsive",
  "platform": "Platform",
  "platform_tenant": "Tenant",
  "platform_tenant_remark": "This field is used as a remark to describe the menu function",
  "platform_tenant_add": "Add Tenant",
  "platform_tenant_add_api": "Add Tenant API",
  "system": "System",
  "system_organization": "Organization",
  "system_users": "Users",
  "system_users_remark": "This field is used as a remark to describe the menu function",
  "system_roles": "Roles",
  "system_user_add": "Add User"
}
